import SelectRadio from '../../../components/common/select-radio/SelectRadio'
import { SelectAssignmentLicense } from '../../../constants'

const ChooseAssignmentLicenseContent = ({
  assignmentOrLicense,
  changeAssignmentOrLicense,
  disableSelection,
}) => {
  return (
    <div
      className={`choose-assignment-license-content${
        disableSelection ? ' disabled' : ''
      }`}>
      <div className="options">
        <div
          className={`option ${
            assignmentOrLicense === SelectAssignmentLicense.License
              ? 'selected'
              : ''
          }`}
          onClick={() =>
            changeAssignmentOrLicense(SelectAssignmentLicense.License)
          }>
          <SelectRadio
            title="Choose licensing if you want to give someone the right to use the
            asset while retaining ownership yourself."
            selected={assignmentOrLicense === SelectAssignmentLicense.License}
          />
        </div>
        <div
          className={`option ${
            assignmentOrLicense === SelectAssignmentLicense.Assignment
              ? 'selected'
              : ''
          }`}
          onClick={() =>
            changeAssignmentOrLicense(SelectAssignmentLicense.Assignment)
          }>
          <SelectRadio
            selected={
              assignmentOrLicense === SelectAssignmentLicense.Assignment
            }
            title="Choose assignment if you want to transfer ownership entirely, giving
            the other party full control of the asset."
          />
        </div>
      </div>
    </div>
  )
}

export default ChooseAssignmentLicenseContent
